<script>
  import OpportunityTeamsTable from "../components/opportunityTeamsTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;

  const mountOpportunityTeamsCount = async () => {
    const module = await import("App/OpportunityTeams/count");
    const OpportunityTeamsCount = module.default;

    if (el1) {
      el1.innerHTML = "";
      new OpportunityTeamsCount({
        target: el1,
      });
    }
  };

  mountOpportunityTeamsCount();
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
    <div class="uimodule">
      <OpportunityTeamsTable />
    </div>
  </div>
</PageContainer>
